<script setup lang="ts">
    const props = defineProps<{
        digest: string;
        lang: string;
    }>();

    const runtimeConfig = useRuntimeConfig();
    const { t } = useI18n();
</script>

<template>
    <LightningOut
        script-key="bonus_lightning_out"
        :script-src="runtimeConfig.public.bonus.scriptSrc"
        :endpoint="runtimeConfig.public.bonus.endpoint"
        app-name="c:VdmcLoyaltyHubApp"
        component-name="c:VdmcLoyaltyHub"
        :component-props="{ hash: props.digest, lang: props.lang }"
    >
        <template #error>
            <p class="bonus-error">{{ t('account.bonus.unavailable') }}</p>
        </template>
    </LightningOut>
</template>
